import TopContainer from "./TopContainer";
import { useLocation } from "react-router-dom";
import "./topMenu.css";
import { useState, useEffect, useCallback, useRef } from "react";
import introJs from "intro.js";
import Cookies from "universal-cookie";
import TutorialLogic from "./TutorialLogic";
import { useTranslation } from "react-i18next";
import useRoutes from "../../../Routes/routes";

const cookies = new Cookies();

const TopMenu = () => {
    const { t } = useTranslation("menu");
    const allRoutes = useRoutes();
    let location = useLocation();
    let [username, setUsername] = useState("...");
    const [introJsInstance] = useState(() => {
        return introJs();
    });
    let hasIntroJsStarted = useRef(false);

    // Function to find the correct child routes based on the current path
    // These are the routes to populate the links in the tabs
    const findMatchingChildRoutes = (currentPath, curRoutes = allRoutes) => {
        for (const route of curRoutes) {
            if (currentPath.startsWith(route.path) && route.children) {
                const childRoutes = route.children;

                const hasNestedChildren = childRoutes.some(
                    (child) => child.children,
                );

                if (hasNestedChildren) {
                    return findMatchingChildRoutes(currentPath, childRoutes);
                }

                return childRoutes;
            }
        }
        return [];
    };

    const findMatchingTitle = (currentPath, curRoutes = allRoutes) => {
        for (const route of curRoutes) {
            if (route.children) {
                let result = findMatchingTitle(currentPath, route.children);
                if (result) return result;
            }
            if (currentPath == route.path) {
                return route.mainTitle;
            }
        }
    };

    const routes = findMatchingChildRoutes(location.pathname);
    const title = findMatchingTitle(location.pathname);
    const startIntroJs = useCallback(() => {
        // This is a bit strange but if we want to ensure that keyboard enter presses
        // don't cause the intro to come back, we must ensure that start
        // is only called ONCE.
        if (!hasIntroJsStarted.current) {
            introJsInstance.setOptions({
                nextLabel: t("introJsContinueButton"), // Change the text for the Next button
                prevLabel: t("introJsBackButton"), // Change the text for the Previous button
                skipLabel: t("introJsSkipButton"), // Change the text for the Skip button
                doneLabel: t("introJsFinishButton"),
            });
            introJsInstance.start();
            hasIntroJsStarted.current = true;
        }
    }, [introJsInstance, hasIntroJsStarted]);

    const setTutorialExitCallback = useCallback(
        (cb) => {
            if (!hasIntroJsStarted.current) {
                introJsInstance.onexit(cb);
            }
        },
        [introJsInstance, hasIntroJsStarted],
    );

    useEffect(() => {
        if (cookies.get("twitch_user")) {
            setUsername(cookies.get("twitch_user"));
        }
    }, []);

    const getMenuOptions = () => {
        // This is a little weird, but because react route requires that the routes least specific
        // are at the end of the array, the last route in the routes array will be the
        // default route for the menu.  This means we want to pop it off the end and put
        // it at the beginning in order to order the routes correctly.
        // We must make a copy as to not modify the original routes array.
        let routesCopy = routes.map((route) => {
            return route;
        });
        let newRoutesArray = [];

        if (routesCopy.length) {
            let lastRoute = routesCopy.pop();
            newRoutesArray = [lastRoute, ...routesCopy];
        }

        return newRoutesArray.map((route) => {
            let isActive = location.pathname.endsWith(route.path);
            let link = `${route.path}`;
            if (route.title) {
                return (
                    <TutorialLogic
                        key={link}
                        title={route.title}
                        link={link}
                        isActive={isActive}
                        startTutorial={startIntroJs}
                        setTutorialExitCallback={setTutorialExitCallback}
                    />
                );
            } else {
                return null;
            }
        });
    };
    return (
        <>
            <TopContainer
                username={username}
                title={title}
                getMenuOptions={getMenuOptions}
            />
        </>
    );
};

export default TopMenu;
